import { CatHeading } from '@blocks-react/components/Heading';
import { ProductCardPriceProps } from '../types';
import styles from '../Product.module.scss';

export const ProductCardStrikedUnitPrice = ({
  price,
  currency
}: ProductCardPriceProps) => {
  return (
    <>
      <CatHeading variant="label-sm" className="me-1">
        <span className={`${styles['product-comparison--unit-price']} text-line-through`}>
          {price}
        </span>
      </CatHeading>
      <CatHeading variant="footnote">
        <span className={`${styles['product-comparison--unit-price']}`}>
          {currency}
        </span>
      </CatHeading>
    </>
  );
};
